import {GATrackingEvent} from '../ga-tracking-event.model';
import {GATrackingEventPayload} from '../ga-tracking-event-payload.model';
import {GATrackingEventType} from '../../constants';

export class GATrackingPlpCategoryFilterClickEvent implements GATrackingEvent {

  constructor(private categoryName: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PLPCategoryFilterClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: 'category_filter_on_PLP',
      label: this.categoryName,
    };
  }
}

